module.exports = __webpack_public_path__ + "static/fonts/Fontfabric - Nexa-Book.459f4dc6.otf";